import React, { useContext } from 'react';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import { BrandContext } from '../../contextProviders/brandContext';
import { CONTACT_US_MESSAGE } from '../../constants/constants';

export const ContactUsDetails = ({ message = CONTACT_US_MESSAGE.DEFAULT, showIcon = true }) => {
  const {
    activeBrandContext: {
      brand: { supportEmailAddress, supportPhoneNumber }
    }
  } = useContext(BrandContext);
  return (
    <section className="contactUs">
      {showIcon && (
        <div className="petIcons">
          <Icon icon="dog-phone" />
        </div>
      )}

      <h2 className="contactUstHeading">
        <span>{message}</span>
      </h2>

      <big className="supportPhoneNumber">{supportPhoneNumber}</big>
      <a
        className="homeUrl"
        rel="noreferrer"
        href={`mailto:${supportEmailAddress}`}
      >
        {supportEmailAddress}
      </a>
    </section>
  );
};

ContactUsDetails.propTypes = {
  message: PropTypes.string,
  showIcon: PropTypes.bool
};
